export default "__VITE_ASSET__iBtioHIy__"